<template>
  <div class="finance">
    <div class="main-wrap">
      <div id="main-content">
        <div class="wrapper">
          <jm-crumbs />

          <div class="table-agile-info" v-loading="loading">
            <div class="common-new-title mode2">
              <span>{{ id ? '编辑佣金' : '添加佣金' }}</span>
              &nbsp; &nbsp;
              <a href="https://www.safe.gov.cn"
                 target="_blank"
                 style="color:green;margin-left:20px">
                <i class="el-icon-date"></i> 查询当月汇率
              </a>
            </div>

            <!-- 财务创建/编辑，状态:-1 -->
            <template v-if="!id || (id && formData.finance_status < 0)">
              <el-row class="info-manag-wrap">
                <template v-if="id">
                  <el-col :lg="8" :md="12" :sm="24">
                    <label>报帐ID:</label>
                    <span>
                      <el-tag><strong>#{{ id }}</strong></el-tag>
                    </span>
                  </el-col>
                  <el-col :lg="16" :md="12" :sm="24">
                    <label>发起人:</label>
                    <span>{{ formData.creator_uid ? formData.creator_name : '-' }}</span>
                  </el-col>
                </template>

                <el-col :lg="8" :md="12" :sm="24">
                  <label><i style="color: red">*</i>支付金额:</label>
                  <el-input
                    v-model="formData.total_amount"
                    class="jm-input220"
                    placeholder="请输入">
                  </el-input>
                </el-col>
                <el-col :lg="16" :md="12" :sm="24">
                  <label>平台部门:</label>
                  <el-input
                    v-model="formData.project_name"
                    class="jm-input220"
                    disabled
                  />
                </el-col>

                <el-col :lg="8" :md="12" :sm="24">
                  <label><i style="color: red">*</i>支付币种:</label>
                  <el-select
                    filterable
                    clearable
                    v-model="formData.currency_type"
                    class="jm-input220"
                    placeholder="请选择"
                    @change="changeCurrencyType">
                    <el-option
                      v-for="item in searchDs.currency_type"
                      :label="item.value"
                      :key="item.id"
                      :value="item.id"
                    />
                  </el-select>
                </el-col>
                <el-col :lg="16" :md="12" :sm="24">
                  <label><i style="color: red">*</i>收款账户:</label>
                  <el-select
                    filterable
                    clearable
                    v-model="formData.payment_method"
                    class="jm-input220"
                    placeholder="请选择">
                    <el-option
                      v-for="item in searchDs.payment_method"
                      :label="item.value"
                      :key="item.id"
                      :value="item.id"/>
                  </el-select>
                </el-col>

                <el-col :lg="8" :md="12" :sm="24">
                  <label>外币金额:</label>
                  <span v-if="hideRealAmount">-</span>
                  <el-input
                    v-else
                    v-model="formData.real_amount"
                    class="jm-input220"
                    placeholder="请输入">
                  </el-input>
                </el-col>
                <el-col :lg="8" :md="12" :sm="24">
                  <label><i style="color: red">*</i>收款时间:</label>
                  <el-date-picker
                    class="jm-input220"
                    v-model="formData.receive_time"
                    type="datetime"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    placeholder="选择日期时间"/>
                </el-col>
                <el-col :span="24">
                  <label>报帐备注:</label>
                  <el-input
                    style="vertical-align: top"
                    resize="none"
                    type="textarea"
                    rows="5"
                    v-model="formData.commission_memo"
                    class="jm-input400"/>
                </el-col>
              </el-row>
            </template>

            <!-- 财务查看，状态:0,1,2 -->
            <template v-else>
              <el-row class="info-manag-wrap">
                <el-col :lg="8" :md="12" :sm="24">
                  <label>报帐ID:</label>
                  <span>
                    <el-tag><strong>#{{ id }}</strong></el-tag>
                  </span>
                </el-col>
                <el-col :lg="16" :md="12" :sm="24">
                  <label>发起人:</label>
                  <span>{{ formData.creator_name }}</span>
                </el-col>
                <el-col :lg="8" :md="12" :sm="24">
                  <label>合作方:</label>
                  <span>{{ formData.partner_name }}</span>
                </el-col>
                <el-col :lg="16" :md="12" :sm="24">
                  <label>费用类型:</label>
                  <span>{{ formData.commission_kind_str }}</span>
                </el-col>
                <el-col :lg="8" :md="12" :sm="24">
                  <label>支付金额:</label>
                  <span class="total_amount">{{ formData.total_amount }}</span>
                </el-col>
                <el-col :lg="16" :md="12" :sm="24">
                  <label>平台部门:</label>
                  <span>{{ formData.project_name }}</span>
                </el-col>
                <el-col :lg="8" :md="12" :sm="24">
                  <label>支付币种:</label>
                  <span>{{ formData.currency_type_str }}</span>
                </el-col>
                <el-col :lg="16" :md="12" :sm="24">
                  <label>收款账户:</label>
                  <span>{{ formData.payment_method_str }}</span>
                </el-col>
                <el-col :lg="8" :md="12" :sm="24">
                  <label>外币金额:</label>
                  <span v-if="hideRealAmount">-</span>
                  <span v-else class="real_amount">{{ formData.real_amount }}</span>
                </el-col>
                <el-col :lg="8" :md="12" :sm="24">
                  <label>收款时间:</label>
                  <span>{{ formData.receive_time }}</span>
                </el-col>
                <el-col :span="24">
                  <label>报帐备注:</label>
                  <div class="jm-input500 el-textarea pre">{{ formData.commission_memo }}</div>
                </el-col>
                <el-col :span="24" style="padding: 20px 0">
                  <label class="text-point">业务附件:</label>
                  <div class="upload-button display-inlineblock">
                    <ul class="el-upload-list el-upload-list--text">
                      <li v-for="(file, index) in formData.business_file" :key="file.uid" :tabindex="index" class="el-upload-list__item is-success">
                        <a class="el-upload-list__item-name" @click="handelUploadPreview(file)">
                          <i class="el-icon-document"></i>
                          {{ file.name }}
                        </a>
                      </li>
                    </ul>
                  </div>
                </el-col>
                <el-col :span="24">
                  <label>返佣明细:</label>
                  <div style="width:80%" class="display-inlineblock">
                    <el-table
                      size="small"
                      :data="formData.commission_details"
                      style="width: 100%">
                      <el-table-column prop="dept_name" label="部门" />
                      <el-table-column prop="commission_type_str" label="费用类型" />
                      <el-table-column prop="dept_total_amount" label="支付金额" />
                      <el-table-column prop="dept_real_amount" label="外币金额" />
                    </el-table>
                  </div>
                </el-col>
              </el-row>
            </template>

            <div class="border"></div>
            <!-- 财务审核 -->
            <el-row class="info-manag-wrap">
              <el-col :span="24">
                <label>财务附件:</label>
                <jm-upload
                  v-if="formData.finance_status === 0 || formData.finance_status === -1"
                  class="upload-button display-inlineblock"
                  action="/newfib.php/finance/commission/uploadOnlineFile"
                  :file-list="formData.finance_file"
                  :on-preview="handelUploadPreview"
                  :on-remove="financeUploadRemove"
                  :on-success="financeUploadSuccess"
                  :show-file-list="true">
                  <el-button size="small" type="primary">上传文件</el-button>
                </jm-upload>
                <div v-else class="upload-button display-inlineblock">
                  <ul class="el-upload-list el-upload-list--text">
                    <li v-for="(file, index) in formData.finance_file" :key="file.uid" :tabindex="index" class="el-upload-list__item is-success">
                      <a class="el-upload-list__item-name" @click="handelUploadPreview(file)">
                        <i class="el-icon-document"></i>
                        {{ file.name }}
                      </a>
                    </li>
                  </ul>
                </div>
              </el-col>

              <el-col :span="24">
                <label>审核状态:</label>
                <template v-if="formData.finance_status === 0">
                  <el-radio-group v-model="formData.financeStatusValue">
                    <el-radio :label="1" border>审核通过</el-radio>
                    <el-radio :label="2" border>拒绝</el-radio>
                  </el-radio-group>
                </template>
                <el-tag v-else :type="tagColors[formData.finance_status]">
                  {{ formData.finance_status_str }}
                </el-tag>
              </el-col>

              <el-col :span="24" v-if="(formData.financeStatusValue === 1 && formData.finance_status === 0) || formData.finance_status === 1">
                <label>到账日期:</label>
                <el-date-picker
                  v-if="formData.finance_status === 0"
                  class="jm-input220"
                  v-model="formData.verify_time"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期">
                </el-date-picker>
                <span v-else>{{ formData.verify_time }}</span>
              </el-col>

              <el-col :span="24" v-if="(formData.financeStatusValue === 2 && formData.finance_status === 0) || formData.finance_status === 2">
                <label>审核备注:</label>
                <el-input
                  v-if="formData.finance_status === 0"
                  style="vertical-align: top"
                  resize="none"
                  type="textarea"
                  rows="5"
                  v-model="formData.verify_message"
                  class="jm-input400">
                </el-input>
                <div v-else class="jm-input500 el-textarea pre">{{ formData.verify_message }}</div>
              </el-col>
            </el-row>

            <!-- 操作按钮 -->
            <div class="jm-button-wrap jm-tac">
              <template v-if="formData.id">
                <el-button v-if="formData.finance_status === -1" type="primary" @click="saveCommission()" :loading="btnLoading">
                  修改订单
                </el-button>

                <template v-if="formData.finance_status === 0">
                  <el-button v-if="formData.financeStatusValue === 1" type="success" @click="verifyCommission()" :loading="btnLoading">
                    审核通过
                  </el-button>
                  <el-button v-else-if="formData.financeStatusValue === 2" type="danger" @click="verifyCommission()" :loading="btnLoading">
                    拒绝
                  </el-button>
                  <el-button v-else type="primary" disabled>
                    保存
                  </el-button>
                </template>
                <!-- <el-button v-if="formData.finance_status > 0" type="primary" @click="$router.back()">
                    返回
                  </el-button> -->
              </template>
              <template v-else>
                <el-button type="primary" @click="saveCommission()" :loading="btnLoading">
                  创建返佣报账
                </el-button>
              </template>
            </div>

          </div>
        </div>
      </div>
    </div>
    <!-- 图片预览 -->
    <el-dialog :visible.sync="fileImageDialogVisible" :width="fileImageWidth" :show-close="false" custom-class="imagePreview">
      <img :src="fileImageUrl" :title="fileImageName" width="100%" />
    </el-dialog>
  </div>
</template>
<script>
import 'element-ui/lib/theme-chalk/display.css';
import crumbs from '@/components/tool/crumbs';
import tableList from '@/components/data/tableList';
import { formatSelectGroupData, checkImageUrl } from '@/utils/utils';

const tagColors = {
  2: 'danger',
  1: 'success',
  0: 'warning',
};

export default {
  data() {
    return {
      tagColors,
      btnLoading: false,
      loading: true,
      searchDs: {
        create_list: []
      },
      formData: {
        id: 0,
        financeStatusValue: 0,
        finance_status: -1,
        finance_status_str: '待补全',
        project_id: 1213,
        project_name: '芥末留学+前程日本',
        creator_uid: '',
        creator_name: '',
        partner_id: '',
        partner_name: '',
        commission_type: '',
        total_amount: '',
        real_amount: '',
        currency_type: '',
        payment_method: '',
        receive_time: '',
        create_time: '',
        update_time: '',
        finance_time: '',
        commission_memo: '',
        verify_time: '',
        verify_message: '',
        finance_file: [],
        business_file: [],
        commission_details: []
      },
      /* 图片预览 */
      fileImageDialogVisible: false,
      fileImageUrl: '',
      fileImageName: '',
      fileImageWidth: '65%'
    };
  },
  computed: {
    id() {
      if (this.$route.params === undefined) {
        return false;
      }
      return this.$route.params.id;
    },
    hideRealAmount() {
      return this.formData.currency_type === '' || this.formData.currency_type === 1;
    }
  },
  methods: {
    // 订单保存
    saveCommission(data) {
      this.formData = Object.assign({}, this.formData, data || {});

      this.btnLoading = true;
      this.$http
        ._post({
          url: '/finance/commission/saveCommission',
          data: this.formData
        })
        .then(() => {
          this.$router.push('/finance/commissionList');
          this.$message.success('保存成功');
        })
        .finally(() => {
          this.btnLoading = false;
        });
    },
    // 审核报账
    verifyCommission() {
      this.btnLoading = true;

      let verifyData = {
        id: this.formData.id,
        financeStatus: this.formData.financeStatusValue,
        financeFile: this.formData.finance_file,
        verifyTime: this.formData.verify_time,
        verifyMessage: this.formData.verify_message
      };

      this.$http
        ._post({
          url: '/finance/commission/verifyCommission',
          data: verifyData
        })
        .then(() => {
          this.$router.push('/finance/commissionList');
          this.$message.success('操作成功');
        })
        .finally(() => {
          this.btnLoading = false;
        });
    },
    // 获取页面数据
    getFormData(commissionId) {
      this.$http
        ._post({
          url: '/finance/commission/find',
          data: { id: commissionId }
        })
        .then((res) => {
          this.formData = res.data;
          // 更新字典
          this.getSearchDs(this.formData.project_id);
        });
    },
    getSearchDs(projectId) {
      this.$http._post({
        url: '/finance/commission/searchDs',
        data: { projectId: projectId }
      }).then(({ data }) => {
        this.loading = false;
        this.searchDs = data;
        this.searchDs.create_list = formatSelectGroupData(data.create_list);
      });
    },
    financeUploadSuccess(response, file, fileList) {
      if (response.result === -1) {
        this.$message.error(response.msg);
        this.formData.finance_file = fileList.filter((f) => {
          return f.uid !== file.uid;
        });
      } else {
        this.formData.finance_file.push({
          url: response.data.url,
          name: response.data.name,
          path: response.data.path,
        });
      }
    },
    financeUploadRemove(file, fileList) {
      this.formData.finance_file = fileList;
    },
    handelUploadPreview(file) {
      if (!checkImageUrl(file.url)) {
        this.downloadFile(file);
      } else {
        this.previewImage(file);
      }
    },
    changeCurrencyType() {
      if (this.hideRealAmount) {
        this.formData.real_amount = '';
      }
    },
    // 文件类型
    checkImageUrl(fileUrl) {
      return checkImageUrl(fileUrl);
    },
    // 下载文件
    downloadFile(file) {
      this.$message.success(`附件"${file.name}"下载完成`);
      this.$http.getFile({
        url: file.url,
        filename: file.name
      });
    },
    // 预览图片
    previewImage(file) {
      this.fileImageDialogVisible = true;
      this.fileImageName = file.name;
      this.fileImageUrl = file.url;
      this.fileImageWidth = '60%';
    }
  },
  components: {
    'jm-crumbs': crumbs,
    'jm-tableList': tableList,
  },
  mounted() {
    if (this.id) {
      // 编辑
      this.getFormData(this.id);
      // this.isCreate = false;
    } else {
      // 创建
      this.getSearchDs(this.formData.project_id);
    }
  },
  watch: {
  }
};
</script>
<style scoped lang="less">

</style>
<style>
  .border{
    border-top:1px dashed #ccc;
    margin:10px 40px;
  }
  .info-manag-wrap .el-col {
    min-height: 41px;
    line-height: 36px;
    margin-bottom: 4px;
  }
  .info-manag-wrap .el-col > label {
    min-width: 100px;
    text-align: right;
    margin: 0 14px 0 0;
    font-weight: 900;
    font-size: 12px;
    display: inline-block;
  }
  .pre {
    vertical-align: top;
    white-space: pre-wrap;
    word-wrap: break-word;
  }
  .total_amount{
    font-weight: bold;
    font-size: 16px;
    color: green;
  }
  .real_amount{
    font-weight: bold;
    font-size: 16px;
    color: royalblue;
  }
  /* 图片预览 */
  .imagePreview .el-dialog__header {
    display: none;
  }
  .imagePreview .el-dialog__body {
    padding: 2px;
  }
</style>
